import { EditorView, Decoration, WidgetType } from '@codemirror/view'
import { syntaxTree } from '@codemirror/language'
import { RangeSetBuilder } from '@codemirror/state'

const hiddenMark = Decoration.mark({ class: 'cm-md-hidden' })

function isInRange(cursor, from, to) {
  return cursor >= from && cursor <= to
}

function buildDecorations(view) {
  const builder = new RangeSetBuilder()
  const cursor = view.state.selection.main.head
  const tree = syntaxTree(view.state)

  tree.iterate({
    enter(node) {
      const { from, to } = node
      const cursorInNode = isInRange(cursor, from, to)

      if (node.name === 'Emphasis' || node.name === 'StrongEmphasis') {
        if (!cursorInNode) {
          const text = view.state.sliceDoc(from, to)
          const markerLen = node.name === 'StrongEmphasis' ? 2 : 1
          if (from + markerLen <= to - markerLen) {
            builder.add(from, from + markerLen, hiddenMark)
            builder.add(to - markerLen, to, hiddenMark)
          }
        }
        return false
      }

      if (node.name === 'InlineCode') {
        if (!cursorInNode) {
          const text = view.state.sliceDoc(from, to)
          const startTicks = text.match(/^`+/)?.[0]?.length || 1
          const endTicks = text.match(/`+$/)?.[0]?.length || 1
          builder.add(from, from + startTicks, hiddenMark)
          builder.add(to - endTicks, to, hiddenMark)
        }
        return false
      }

      if (node.name === 'ATXHeading1' || node.name === 'ATXHeading2' || node.name === 'ATXHeading3' ||
          node.name === 'ATXHeading4' || node.name === 'ATXHeading5' || node.name === 'ATXHeading6') {
        if (!cursorInNode) {
          const line = view.state.doc.lineAt(from)
          const match = line.text.match(/^(#{1,6})\s/)
          if (match) {
            builder.add(from, from + match[0].length, hiddenMark)
          }
        }
      }

      if (node.name === 'Link') {
        if (!cursorInNode) {
          const text = view.state.sliceDoc(from, to)
          const match = text.match(/^\[([^\]]*)\]\(([^)]*)\)$/)
          if (match) {
            builder.add(from, from + 1, hiddenMark)
            builder.add(from + 1 + match[1].length, to, hiddenMark)
          }
        }
        return false
      }

      if (node.name === 'Strikethrough') {
        if (!cursorInNode) {
          builder.add(from, from + 2, hiddenMark)
          builder.add(to - 2, to, hiddenMark)
        }
        return false
      }
    },
  })

  return builder.finish()
}

export const hideMarkdown = EditorView.decorations.compute(['doc', 'selection'], (state) => {
  const view = { state }
  return buildDecorations(view)
})

export const hideMarkdownTheme = EditorView.baseTheme({
  '.cm-md-hidden': {
    fontSize: '0',
    display: 'inline',
    width: '0',
    overflow: 'hidden',
  },
})
